<template>
  <main class="container">
    <div class="checkmark">
      <CheckmarkIcon class="icon" />
    </div>

    <h1 class="page-title">Good News!</h1>

    <p>
      One of your housemates has done the hard work and already created an
      account for <span class="address">{{ address }}</span>
      <span v-if="!address">this address</span>
    </p>

    <p class="join-info">
      To join this account simply click the button below
    </p>

    <button class="btn btn--full-width btn--big" @click="joinExistingAccount">
      Join This Account
    </button>
  </main>
</template>

<script>
import CheckmarkIcon from "@/assets/svg/check.svg";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "AccountAlreadyExists",
  props: {
    guid: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      address: "getCustomerAddressString",
    }),
  },
  methods: {
    ...mapMutations({
      resetState: "RESET_STATE",
    }),
    joinExistingAccount() {
      this.resetState();
      this.$router.push({
        path: "joining-tenant",
        query: {
          guid: this.guid,
        },
      });

      this.trackGoogleEvent("Click Join", "Create Account", "Join account");
    },
  },
  created() {
    // ensure back btn is hidden
    this.$store.commit("HIDE_BACK_BTN");

    this.trackGoogleEvent(
      "Land on account already created page",
      "Create Account",
      "Account already created",
    );
  },
  components: {
    CheckmarkIcon,
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  max-width: 55rem;
}

.checkmark {
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background-color: $brand-blue;
  width: 100px;
  height: 100px;
  margin: $spacing-large auto 0 auto;

  .icon {
    fill: white;
    width: 60px;
    height: 100px;
  }
}

.address {
  font-weight: $font-bold;
  color: $brand-dark-blue;
}

p {
  font-size: 16px;
  color: $grey-dark;
}

.join-info {
  color: $brand-dark-blue;
  font-weight: $font-bold;
}
</style>
